import { Grid2 as Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	container: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		width: "100%",
	},
	colorCircle: {
		width: "26px",
		height: "26px",
		borderRadius: 4,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff",
		fontWeight: "bold",
		marginRight: "8px",
	},
});

type CategoryTagProps = {
	value: {
		name: string;
		color: string;
	};
};

export const CategoryTag = ({
	value,
}: {
	value: CategoryTagProps["value"];
}) => {
	const classes = useStyles();

	if (!value || !value.name || !value.color) {
		return null;
	}

	return (
		<Grid container direction="row" spacing={1}>
			<Grid size={{ xs: 2, md: 2 }}>
				<div
					title={value.name}
					className={classes.colorCircle}
					style={{ backgroundColor: value.color }}
				>
					{value.name.charAt(0).toUpperCase()}
				</div>
			</Grid>
			<Grid size={{ xs: 10, md: 10 }} justifyContent="center">
				{value.name}
			</Grid>
		</Grid>
	);
};
